import React, { useEffect } from "react";
import { ContentPagePanel } from "../helpPage/HelpPage";
import AuthLayout from "../../components/layout/AuthLayout";
import { trivia } from "../../../Data";
import { useLogEvent } from "../../hooks/api/post"; 


function RulesPage() {
   const { mutate: logEvent } = useLogEvent();
    const userInfo = JSON.parse(sessionStorage.getItem("ccAuth"));
  
    useEffect(() => {
      if (userInfo?.id) {
        logEvent({
          userId: userInfo.id,
          action_type: "Rules_load",
        });
      }
    }, [userInfo?.id, logEvent]);

  const triviaList = trivia.rules.map((data) => {
    data.content = data.text;
    if (!data.title) {
      data.title = "";
    }
    return data;
  });
  return (
    <AuthLayout>
      <ContentPagePanel title="Rules" options={triviaList} />
    </AuthLayout>
  );
}

export default RulesPage;
